module.exports = __webpack_public_path__ + "img/10.6e6bf049.jpg";